import i18next from 'i18next';
import resources from './resources';

i18next.init({
  resources: {},
  defaultNS: 'sydle-ui',
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
});

i18next.addResourceBundle('pt', 'sydle-ui', getLanguage(resources, 'pt'));
i18next.addResourceBundle('en', 'sydle-ui', getLanguage(resources, 'en'));
i18next.addResourceBundle('es', 'sydle-ui', getLanguage(resources, 'es'));

function getLanguage(resources: Record<string, Record<string, string>>, language: string) {
  const translations: Record<string, string> = {};
  Object.keys(resources).forEach((key) => {
    translations[key] = resources[key][language];
  });
  return translations;
}

export function t(key: string, defaultValue: string, args?: Array<string>): string {
  const i18nextOptions = {
    defaultValue,
  };

  i18next.changeLanguage(getCurrentLanguage());

  if (args && args.length > 0) {
    args.forEach((arg, index) => {
      i18nextOptions[index] = arg;
    });
  }

  return i18next.t(`sydle-ui:${key}`, i18nextOptions);
}

function getCurrentLanguage(defaultLanguage?: string): string {
  const CURRENT_LANGUAGE = 'explorer_current_language';
  const DEFAULT_LANGUAGE = 'pt';

  return (
    sessionStorage.getItem(CURRENT_LANGUAGE) ||
    localStorage.getItem(CURRENT_LANGUAGE) ||
    defaultLanguage ||
    (typeof navigator !== 'undefined' && navigator.language?.split('-')[0]) ||
    DEFAULT_LANGUAGE
  );
}
